import apiClient from "../../../helpers/apiClient";
import i18n from "../../../config/i18_init";

const INSURANCE_START_ENDPOINTS = {
    teqMobility: "/api/insurance/start-teqMobility-coverage",
    bonzah: "/api/insurance/start-bonzah-coverage",
    abi: "/api/insurance/start-abi-coverage",
};

export async function startInsuranceForCheckIn(reservationId, insuranceType, toast) {
    const endpoint = INSURANCE_START_ENDPOINTS[insuranceType];
    if (!endpoint) return;

    try {
        const { data } = await apiClient.post(endpoint, { reservationId });
        if (!data?.success) {
            throw new Error(data?.message || i18n.t("checkIn:failedToStartInsuranceDescription"));
        }
    } catch (error) {
        const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            i18n.t("checkIn:failedToStartInsuranceDescription");
        if (toast) {
            toast.error({
                message: i18n.t("checkIn:failedToStartInsurance"),
                description: errorMessage,
            });
        }
        throw error;
    }
}
export const INSURANCE_PROVIDERS = ["teqMobility", "bonzah", "abi"];
